import { isDefined } from "Utils/functions";
import { CabinContentsSum } from "./cabinContentsConstants";

export const isContentsInsuranceSumValid = (
  contentsInsuranceSum: number | undefined,
): boolean =>
  isDefined(contentsInsuranceSum) &&
  contentsInsuranceSum >= CabinContentsSum.LOWER_LIMIT &&
  contentsInsuranceSum <= CabinContentsSum.UPPER_LIMIT;

export const isContentsInsuranceSumTooHigh = (
  contentsInsuranceSum: number | undefined,
): boolean =>
  isDefined(contentsInsuranceSum) &&
  contentsInsuranceSum > CabinContentsSum.UPPER_LIMIT;
